import { create } from 'zustand';
import { errorDetail, errorMessage } from './api-error';

/**
 * Uygulama genelinde tek bildirim kuyruğu.
 *
 * snak'ta toast hiç yoktu; geri bildirim 53 ayrı `useState('')` ve 49 inline
 * kırmızı yazıya dağılmıştı. Sonuç: bir mutasyon sayfa değişince sessizce
 * kayboluyordu ve "kaydedildi mi?" sorusunun cevabı sayfaya göre değişiyordu.
 *
 * Store BİLEREK React dışından da çağrılabilir (`toast.error(err)`): hata
 * çoğu zaman bir mutasyon geri çağrısında oluşur ve orada hook kullanılamaz.
 */

export type ToastKind = 'success' | 'error' | 'info';

export interface Toast {
  id: number;
  kind: ToastKind;
  message: string;
  /** 500'lerde operatörün paylaşabileceği tek şey iz numarasıdır. */
  detail: string | null;
}

interface ToastState {
  toasts: Toast[];
  push: (toast: Omit<Toast, 'id'>) => number;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (toast) => {
    const id = nextId++;
    set((state) => ({ toasts: [...state.toasts, { ...toast, id }] }));
    return id;
  },
  dismiss: (id) => set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));

/** Başarı bildirimi kendiliğinden kapanır; hata KAPANMAZ — operatör görmeli. */
const AUTO_DISMISS_MS: Record<ToastKind, number | null> = {
  success: 4000,
  info: 6000,
  error: null,
};

function show(kind: ToastKind, message: string, detail: string | null = null): void {
  const id = useToastStore.getState().push({ kind, message, detail });
  const ms = AUTO_DISMISS_MS[kind];
  if (ms !== null) {
    setTimeout(() => useToastStore.getState().dismiss(id), ms);
  }
}

export const toast = {
  success: (message: string) => show('success', message),
  info: (message: string) => show('info', message),
  /**
   * Doğrudan yakalanan hatayı alır — çağrı noktası `code`u çözmek zorunda
   * kalmasın diye. Ham `err.message` hiçbir yolla ekrana çıkmaz.
   */
  error: (err: unknown) => show('error', errorMessage(err), errorDetail(err)),
  /** Sunucu hatası olmayan, panelin kendi ürettiği uyarı. */
  errorText: (message: string) => show('error', message),
  dismiss: (id: number) => useToastStore.getState().dismiss(id),
};
